export enum AppRole {
  ADMIN = "ADMIN",
  USER = "USER"
}